module.exports = __webpack_public_path__ + "assets/icon-gallery.ff93f28f.svg";